import { render, staticRenderFns } from "./ShiftWork_V2.vue?vue&type=template&id=37ca4816&scoped=true&"
import script from "./ShiftWork_V2.vue?vue&type=script&lang=js&"
export * from "./ShiftWork_V2.vue?vue&type=script&lang=js&"
import style0 from "./ShiftWork_V2.vue?vue&type=style&index=0&id=37ca4816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca4816",
  null
  
)

export default component.exports